
import { Link } from "react-router-dom";
import "../Services.css";
import { useState } from "react";

const FAQSection = () => {
  const faqs = [
    {
      question: "1. What tax services do you offer?",
      answer:
        "We offer a wide range of tax services, including individual and business tax preparation, tax planning, compliance, and filing for federal, state, and local taxes.",
    },
    {
      question: "2. How do you ensure tax compliance?",
      answer:
        "We stay updated with the latest tax laws and regulations to ensure your tax filings are accurate, timely, and fully compliant with federal and state requirements.",
    },
    {
      question: "3. Do you handle international tax filings?",
      answer:
        "Yes, we assist with international tax filings, including foreign income reporting.",
    },
    {
      question: "4. What is the deadline for filing taxes?",
      answer:
        "The tax filing deadline is typically April 15th for individual returns, but it may vary depending on your business type and circumstances. We can help you stay on track with important dates.",
    },
    {
      question: "5. Do you offer year-round tax support?",
      answer:
        "Yes, our services are not limited to tax season. We offer year-round tax guidance, planning, and support to help you stay prepared and avoid surprises.",
    },
    {
      question: "6. How do you protect my personal and financial information?",
      answer:
        "We use secure systems and follow strict confidentiality protocols to safeguard your data.",
    },
    {
      question: "7. Can you help me reduce my tax liability legally?",
      answer:
        "Absolutely. We specialize in proactive tax planning strategies designed to maximize deductions and credits, helping you reduce your tax burden while staying fully compliant.",
    },
    {
      question: "8.	What documents do I need to get started with tax preparation?",
      answer:
        "To begin, you'll need income documents (like W-2s or 1099s), expense records, prior year tax returns, and any relevant financial statements. We'll provide you with a full checklist tailored to your filing needs.",
    },
  ];

  const [openIdx, setOpenIdx] = useState(null);
  const toggle = (idx) => setOpenIdx((prev) => (prev === idx ? null : idx));

  return (
    <div className="faq-section py-5">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="section-title1">Tax FAQs</h2>
          <Link to="/pricing" className="see-plan-link">
            See Plan &rarr;
          </Link>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="faq-accordion">
              {faqs.map((faq, index) => {
                const isOpen = openIdx === index;
                const isString = typeof faq.answer === 'string';
                return (
                  <div className="faq-item" key={index}>
                    <button
                      type="button"
                      className="faq-toggle"
                      aria-expanded={isOpen}
                      aria-controls={`faq-content-${index}`}
                      onClick={() => toggle(index)}
                    >
                      <h5 className="faq-question m-0">{faq.question}</h5>
                      <span className="faq-icon" aria-hidden>{isOpen ? '−' : '+'}</span>
                    </button>
                    <div
                      id={`faq-content-${index}`}
                      className={`faq-content ${isOpen ? 'open' : ''}`}
                      role="region"
                    >
                      <div className="faq-content-inner">
                        {isString ? (
                          <p className="faq-answer" style={{ whiteSpace: 'pre-line', marginBottom: 0 }}>{faq.answer}</p>
                        ) : (
                          <div className="faq-answer">{faq.answer}</div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;

